var map = {
	"./default/common.json": 65953,
	"./default/screen.json": 40004,
	"./en/common.json": 34010,
	"./en/screen.json": 46660,
	"./ms/common.json": 97550,
	"./ms/screen.json": 75325,
	"./zh/common.json": 54967,
	"./zh/screen.json": 1570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68262;